import { render, staticRenderFns } from "./StockItems.vue?vue&type=template&id=41f63f2a&"
import script from "./StockItems.vue?vue&type=script&lang=js&"
export * from "./StockItems.vue?vue&type=script&lang=js&"
import style0 from "./StockItems.vue?vue&type=style&index=0&id=41f63f2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports